/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Release_ButtonInputs */



/**
* | output |
* | --- |
* | "Release this computer" |
*
* @param {License_Release_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_release_button = /** @type {((inputs?: License_Release_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Release_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Libérer cet ordinateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Diesen Computer freigeben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Libera questo computer")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Освободить этот компьютер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Liberar este equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("释放此电脑")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このコンピューターを解除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह कंप्यूटर हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Libertar este computador")
	return /** @type {LocalizedString} */ ("Release this computer")
});